//150
function validarDomicilio(long) {
  if (/^[a-zA-Z0-9\s\,\/\.\#\ñ\''\-]{0,150}$/i.test(long)) {
    return "aceptadoDominio";
  } else {
    return "errorDominio";
  }
}

export default validarDomicilio;
